<template>
    <div class="mywrap">
        <div class="meminfo"><Left/></div>
<!--        <div class="portpwc" v-if="member===null">-->
<!--            <a href="/login">请登录</a><span>/</span><a href="/register">注册</a>-->
<!--        </div>-->

        <div class="myrht">

            <section class="member-dashboard-hero" v-if="member">
                <div><small>YAXUN MEMBER INTELLIGENCE</small><h1>亚讯会员研究室</h1><p>统一管理赛事关注、专家订阅、球币记录与个人资料。</p></div>
                <ul><li><i>✓</i><span><b>认证专家</b><small>平台资料核验</small></span></li><li><i>▤</i><span><b>真实记录</b><small>赛果公开可查</small></span></li><li><i>盾</i><span><b>诚信保障</b><small>规则清晰透明</small></span></li></ul>
            </section>

            <div class="memberinfo myrhtinfo" v-if="member">
                <div class="title"><span>会员档案</span><i></i></div>
<!--                <div class="img">-->
<!--                    <img :src="member.portrait">-->
<!--                </div>-->
                <div class="item">
                    <div class="name">账号</div>
                    <div class="con">{{member.name_zs}}</div>
                </div>
                <div class="item">
                    <div class="name">昵称</div>
                    <div class="con">{{member.nick}}</div>
                </div>
                <div class="item">
                    <div class="name">球币</div>
                    <div class="con gold">{{member.gold}}</div>
                </div>
                <div class="item">
                    <div class="name">积分</div>
                    <div class="con">{{member.integral}}</div>
                </div>
                <div class="item">
                    <div class="name">注册</div>
                    <div class="con tme">{{member.create}}</div>
                </div>
                <div class="item">
                    <div class="name">简介</div>
                    <div class="con">{{member.intro}}</div>
                </div>
            </div>

            <div class="member-main-loading" v-else-if="$store.state.token && init">
                <van-skeleton title :row="6"></van-skeleton>
            </div>

            <div class="member-main-state" v-else-if="$store.state.token">
                <div>会员资料暂未加载</div>
                <button type="button" @click="getMemInfo">重新加载</button>
            </div>

        </div>
    </div>


</template>

<script>
    import defPortrait from "../assets/images/default-analyst-v3.jpg";
    import Left from "./my/left";
    export default {
        name: "my",
        components: {Left},
        data (){
          return {
                init: true,
              member: null,

          }
        },
        watch: {
            '$store.state.token': {
                immediate: true,
                handler(token) {
                    if(!token) this.member = null
                    else this.getMemInfo()
                }
            },
        },
        activated() {
            if(this.$store.state.token) this.getMemInfo()
        },
        created() {
        },
        methods: {

            getMemInfo() {
                let that = this
                this.init = true
                this.$post(that.$api.memberinfo).then(function (res) {
                    if (res.code === 1){
                        let data = res.data.member
                        if(data.portrait === null)
                            data.portrait = defPortrait
                        else
                            data.portrait = that.$api.imgBaseUrl + data.portrait
                        that.member = data
                    }
                    that.init = false
                }).catch(function () {
                    that.member = null
                    that.init = false
                })
            },
        }
    }
</script>

<style scoped>
    .member-main-loading{padding:28px 2px;}
    .member-main-state{padding:70px 20px;text-align:center;color:#71899b;}
    .member-main-state button{margin-top:14px;padding:8px 20px;border:0;border-radius:5px;color:#fff;background:#168fd5;cursor:pointer;}
</style>
